import { handleActions, createAction } from 'redux-actions';
import { createFormAction } from 'redux-form-saga';
import update from 'immutability-helper';
import mapActions from '@goodwaygroup/react-map-actions';

// Actions
export const actions = mapActions([
    'CREATE_USER',
    'FETCH_LIST',
    'FETCH_LIST_SUCCESS',
    'FETCH_CURRENT_USER',
    'FETCH_CURRENT_USER_SUCCESS',
    'FETCH_USER',
    'FETCH_USER_SUCCESS',
    'UPDATE_USER',
    'RESET_PASSWORD',
    'RESET_PASSWORD_SUCCESS',
    'SEND_DEBUG',
    'DESTROY_CURRENT_USER_SESSION'
], 'USERS');

// Action Creators
export const createUserForm = createFormAction(actions.CREATE_USER);
export const submitUserForm = createFormAction(actions.UPDATE_USER);
export const fetchList = createAction(actions.FETCH_LIST);
export const listFetched = createAction(actions.FETCH_LIST_SUCCESS);
export const fetchCurrentUser = createAction(actions.FETCH_CURRENT_USER);
export const fetchCurrentUserSuccess = createAction(actions.FETCH_CURRENT_USER_SUCCESS);
export const fetchUser = createAction(actions.FETCH_USER);
export const fetchUserSuccess = createAction(actions.FETCH_USER_SUCCESS);
export const resetPassword = createAction(actions.RESET_PASSWORD);
export const resetPasswordSuccess = createAction(actions.RESET_PASSWORD_SUCCESS);
export const sendUserDebug = createAction(actions.SEND_DEBUG);
export const destroyCurrentUserSession = createAction(actions.DESTROY_CURRENT_USER_SESSION);

// Reducers
const initialState = {
    list: [],
    listFetched: false,
    currentUser: null,
    user: null
};

const fullName = (user) => {
    if (user.lastName) {
        return `${user.firstName} ${user.lastName}`;
    }
    return user.firstName;
};

export default handleActions({
    [actions.FETCH_LIST_SUCCESS]: (state, action) => {
        const userList = action.payload.map((d) => {
            d.fullName = fullName(d);
            return d;
        });
        return update(state, {
            list: { $set: userList },
            listFetched: { $set: true }
        });
    },
    [actions.FETCH_CURRENT_USER_SUCCESS]: (state, action) => update(state, { currentUser: { $set: action.payload } }),
    [actions.FETCH_USER_SUCCESS]: (state, action) => update(state, { user: { $set: action.payload } })
}, initialState);



// WEBPACK FOOTER //
// ./src/services/users/duck.js